import { useQuery } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';

export interface PublicFoodItem {
  id: string;
  name: string;
  description?: string;
  image?: string;
  price: number;
  isVegetarian: boolean;
  isVegan: boolean;
  spiceLevel: number;
  allergens: string[];
  preparationTime?: number;
  category: {
    name: string;
  };
}

interface MenuCategoryGroup {
  category: { id: string; name: string; slug: string; displayOrder: number };
  items: Array<{
    id: string;
    name: string;
    description?: string;
    image?: string;
    originalPrice: number;
    effectivePrice: number;
    isVegetarian: boolean;
    isVegan: boolean;
    spiceLevel: number;
    allergens: string[];
    preparationTime?: number;
    categoryId: string;
  }>;
}

interface MenuResponse {
  data: MenuCategoryGroup[];
  pagination: { total: number; page: number; limit: number };
}

export function usePublicFoodItems(venueId: string) {
  return useQuery({
    queryKey: ['publicFoodItems', venueId],
    queryFn: async (): Promise<PublicFoodItem[]> => {
      const response = await validatedApi.get<MenuResponse>(`/venues/${venueId}/menu`);
      const groups: MenuCategoryGroup[] = Array.isArray(response)
        ? (response as unknown as MenuCategoryGroup[])
        : ((response as MenuResponse).data ?? []);
      return groups.flatMap((group) =>
        group.items.map((item) => ({
          id: item.id,
          name: item.name,
          description: item.description,
          image: item.image,
          price: item.effectivePrice,
          isVegetarian: item.isVegetarian,
          isVegan: item.isVegan,
          spiceLevel: item.spiceLevel,
          allergens: item.allergens,
          preparationTime: item.preparationTime,
          category: { name: group.category.name },
        }))
      );
    },
    enabled: !!venueId,
  });
}
